/* 
 * Copyright    : Good Friends iCreation Sdn Bhd. All Rights Reserved.
 */
import React, { Component } from 'react';

class SnackBarModal extends Component {
    
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div id={this.props.id || ""} className="snackbar-body">
                {/* <div className="modal-dialog {this.props.modalSize || modal-md}">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="modal-two-title">{this.props.title || ""}</h4>
                        </div>
                        <div className="modal-body container-fluid">
                            {this.props.body}
                        </div>
                        <div className="modal-footer">
                            {this.props.getButtons && this.props.getButtons()}
                            <button type="button" className="btn btn-default" data-dismiss="modal" id={"modal-two-cancel-" + this.props.id}>{this.props.btnCancel? this.props.btnCancel: lang.cancel}</button>
                            <button type="submit" onClick={this.props.onSaveClicked} className="btn btn-primary" data-dismiss="modal" id={"modal-two-confirm-" + this.props.id}>{this.props.btnConfirm? this.props.btnConfirm : lang.confirm}</button>
                        </div>
                    </div>
                </div> */}
                {this.props.message}
            </div>
        )
    }
}

export default SnackBarModal;